import { createNamespacedHelpers } from 'vuex';

import { state, mutations } from './mutations';
import { actions } from './actions';
import { getters } from './getters';

export const { mapState, mapActions, mapGetters } = createNamespacedHelpers('assessment');

// TODO: replace with composables (5 days)
const assessmentStore = {
  namespaced: true,
  actions,
  state,
  mutations,
  getters,
};

export default assessmentStore;
